import styled from 'styled-components';
import { StyledProps } from 'types/styles';
import {
  variant,
  borderRadius,
  space,
  fontSize,
  fontWeight,
  layout,
  flexbox,
  color,
  border,
  typography,
} from 'styled-system';
import theme from 'styles/theme';

interface Props extends StyledProps {}

export const Wrapper = styled('button')<Props>(
  {
    appearance: 'none',
    fontFamily: 'inherit',
    display: 'flex',
    userSelect: 'none',
    cursor: 'pointer',
  },
  borderRadius,
  border,
  color,
  space,
  fontSize,
  fontWeight,
  layout,
  flexbox,
  variant({
    variants: {
      primary: {
        borderRadius: '100px',
        color: theme.buttons.primary.default.textColor,
        fontSize: '16px',
        bg: theme.buttons.primary.default.backgroundColor,
        borderColor: theme.buttons.primary.default.borderColor,
        px: 4,
        py: 3,
        '&:hover': {
          bg: theme.buttons.primary.default.hover.backgroundColor,
        },
        '&:active': {
          bg: theme.buttons.primary.default.active.backgroundColor,
        },
        '&:disabled': {
          bg: theme.buttons.primary.disabled.backgroundColor,
          borderColor: theme.buttons.primary.disabled.borderColor,
          opacity: '0.75',
          cursor: 'not-allowed',
          color: theme.buttons.primary.disabled.textColor,
        },
      },
      secondary: {
        borderRadius: '100px',
        color: theme.buttons.secondary.default.textColor,
        fontSize: '16px',
        bg: theme.buttons.secondary.default.backgroundColor,
        borderColor: theme.buttons.secondary.default.borderColor,
        px: 4,
        py: '10px',
        '&:hover': {
          bg: theme.buttons.secondary.default.hover.backgroundColor,
        },
        '&:active': {
          bg: theme.buttons.secondary.default.active.backgroundColor,
        },
        '&:disabled': {
          bg: theme.buttons.secondary.disabled.backgroundColor,
          borderColor: theme.buttons.secondary.disabled.borderColor,
          opacity: '0.75',
          cursor: 'not-allowed',
          color: theme.buttons.secondary.disabled.textColor,
        },
      },
      tertiary: {
        color: 'blacks.1',
        bg: 'grays.5',
        borderColor: 'grays.5',
        '&:hover': {
          bg: 'grays.4',
        },
        '&:disabled': {
          color: 'grays.2',
        },
      },
      highlight: {
        color: 'blues.1',
        bg: 'blues.5',
        borderColor: 'blues.5',
        '&:hover': {
          borderColor: 'blues.5',
          backgroundColor: 'blues.5',
        },
        '&:disabled': {
          borderColor: 'blues.5',
          backgroundColor: 'blues.5',
        },
      },
      outline: {
        color: 'blues.0',
        bg: 'white',
        borderColor: 'grays.3',
        '&:hover': {
          backgroundColor: 'grays.2',
        },
        '&:disabled': {
          color: 'grays.2',
        },
      },
      transparent: {
        color: 'blues.0',
        bg: 'white',
        borderColor: 'transparent',
        '&:hover': {
          backgroundColor: 'none',
        },
        '&:disabled': {
          color: 'grays.1',
        },
      },
      error: {
        color: 'white',
        bg: 'reds.2',
        borderColor: 'transparent',
        '&:hover': {
          backgroundColor: 'reds.1',
        },
      },
      pagination: {
        color: 'blues.2',
        bg: 'blues.4',
        borderColor: 'transparent',
        '&:hover': {
          opacity: '0.95',
        },
      },
      confirmation: {
        borderRadius: '100px',
        '&:hover': {
          bg: 'whites.1',
        },
        '&:active': {
          bg: theme.buttons.secondary.default.active.backgroundColor,
        },
        bg: 'whites.0',
      },
    },
  }),
);

Wrapper.defaultProps = {
  borderRadius: 2,
  px: 3,
  height: '36px',
  fontWeight: 1,
  alignItems: 'center',
  justifyContent: 'center',
  borderWidth: '1px',
  borderStyle: 'solid',
};

export const ButtonContent = styled.div<Props>`
  ${layout}
  ${flexbox}
  ${typography}
  svg {
    ${space}
    width: 16px;
    height: 16px;
  }
`;

export const LoadingWrapper = styled.div<Props>`
  ${layout}
  width: 100%;

  svg {
    ${color}
    ${space}
    height: 24px !important;
  }
`;
